




































































































































































































































































































import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import {
  Input, Button, Select, Option, Radio, Message, Dialog, DatePicker, Checkbox,Loading, Scrollbar
} from 'element-ui';
import MyDialog from '@/components/dialog/Index.vue'; // dialog
import Sign from '@/servers/modules/signinsignup'; // server
import { baseUrl } from '@/utils/axios-request/index';
import { OnGetOS, downloadExe } from '@/plugins/util';

@Component({
  components: {
    Input,
    Button,
    Select,
    Option,
    Radio,
    Dialog,
    Message,
    DatePicker,
    Checkbox,
    Loading,
    Scrollbar
  },
})
export default class extends Vue {
    public isDownload = true

    public systemType = ''

    private step: number = 1;

    // code url
    private codeImgUrl: any = null;

    // dialog
    private dialogVisible: boolean = false;

    // 确认密码
    private passwordSure: any = '';

    // 拼接 区号 固话
    private telephone: string = '';

    private areaCode: string = '';

    // 课程密码获取课程相关数据
    private courseRelatedData: any = {
      // 课程密码
      courseCode: '',
      // 验证码
      verificationCode: '',
      // 获取验证码的唯一标识
      verificationCodeToken: '',
    }

    // 省市数据
    private queryProvenceData: any = []

    // 年级数据
    private realGradeData: any = [];

    // 按钮 loading
    private loading: boolean = false;

    // 获取年纪信息 select
    private realGradeLoading: boolean = false;

    // 课程列表
    // private courseList: any = [
    //     {
    //         productNameAll: '高中人教版',
    //         productId: '123',
    //         productDetailVos: [
    //             {gradeId: '12312', gradeName: '高考冲刺系列之书面表达'},
    //             {gradeId: '12322', gradeName: '高考冲刺系列之书面表达'},
    //             {gradeId: '12333', gradeName: '高考冲刺系列之书面表达'},
    //         ]
    //     },
    //     {
    //         productNameAll: '高中sad人教版',
    //         productId: '777',
    //         productDetailVos: [
    //             {gradeId: '123423', gradeName: '32之书面表达'},
    //             {gradeId: '1233213', gradeName: '32之书面表达'},
    //             {gradeId: '123321', gradeName: '32之书面表达'},
    //         ]
    //     },
    // ];
    //
    private isSeePassword: boolean = false;

    private isSeeSurePassword: boolean = false;

    // 查看密码图标地址
    private get seePasswordUrl() {
      return !this.isSeePassword ? require('@/assets/images/person/icon/unlock.png') : require('@/assets/images/person/icon/lock.png');
    }

    private get passwordType() {
      return !this.isSeePassword ? 'password' : 'text';
    }

    // 查看密码
    private seePassword() {
      this.isSeePassword = !this.isSeePassword;
    }

    // 确认密码一致
    private get seeSurePasswordUrl() {
      return !this.isSeeSurePassword ? require('@/assets/images/person/icon/unlock.png') : require('@/assets/images/person/icon/lock.png');
    }

    private get passwordSureType() {
      return !this.isSeeSurePassword ? 'password' : 'text';
    }

    // 查看密码
    private seeSurePassword() {
      this.isSeeSurePassword = !this.isSeeSurePassword;
    }

    handleClose() {
      this.dialogVisible = false
    }

    private toUrl(obj:object) {
      if (obj.type === '1') {
        window.open('https://www.ambow.com/');
        return;
      }
      this.$router.push({ path: 'about', query: { type: obj.type } });
    }

    // select 加载数据
    private realGradeVisibleChange() {
      this.realGradeLoading = true;
      this.queryGradeList();
    }

    // 加载省市数据
    private provinceVisibleChange() {
      this.realGradeLoading = true;
      this.queryProvence();
    }

    // 重新选择省
    private provinceChange() {
      if (this.registerData.province) {
        this.registerData.city = '';
      }
    }

    private async submit() {
      return false;
      // 校验
      if (!this.registerData.userName) {
        Message.warning('请输入真实姓名'); // 1111111
        return false;
      }
      // if (!/^\d+(\.\d+)?$/.test(this.registerData.realGrade)) {
      //     Message.warning('请选择年级')  // 1111111
      //     return false

      // }
      // if (!this.registerData.birthday) {
      //     Message.warning('请选择出生日期')  // 1111111
      //     return false
      // }
      if (!this.registerData.sex) {
        Message.warning('请选择性别'); // 1111111
        return false;
      }
      if (!this.registerData.province) {
        Message.warning('请选择省'); // 1111111
        return false;
      }
      if (!this.registerData.city) {
        Message.warning('请选择市'); // 1111111
        return false;
      }
      // if (!this.areaCode) {
      //     Message.warning('请输入正确区号')  // 1111111
      //     return false
      // }
      // if (!/^\d{7,8}$/.test(this.telephone)) {
      //     Message.warning('请输入正确固定电话')  // 1111111
      //     return false
      // }
      // if (!/^1[345678]\d{9}$/.test(this.registerData.mobileNumberParent)) {
      //     Message.warning('请输入正确家长手机号')  // 1111111
      //     return false
      // }
      // if (!this.registerData.address) {
      //     Message.warning('输入通讯地址')  // 1111111
      //     return false
      // }
      // if (!this.registerData.zipCode) {
      //     Message.warning('请输入正确邮政编码')  // 1111111
      //     return false
      // }
      // if (!/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(this.registerData.emailParent)) {
      //     Message.warning('请输入正确E-mail')  // 1111111
      //     return false
      // }

      // return
      this.registerData.telephone = `${this.areaCode}-${this.telephone}`;
      this.registerData.coursePassWord = this.courseRelatedData.courseCode;
      this.loading = true;
      const res = await Sign.register(this.registerData).catch((e) => {
        this.loading = false;
      });
      if (res.data.code == 0) {
        this.loading = false;
        Message.success('注册成功');
        this.$router.push(
          {
            path: '/login',
          },
        );
      }
    }

    // 优先选择
    private get priorList() {
      const value = this.courseList.filter((item: any) => item.version == this.registerData.productId);
      console.log();
      if (value && value[0] && value[0].list) {
        const result = value[0].list;
        return result;
      }
      return '';
    }

    // 课程名称
    private get productName() {
      const value = this.courseList.filter((item: any) => item.productId == this.registerData.productId);
      if (value && value[0] && value[0].productNameAll) {
        const result = value[0].productNameAll;
        return result;
      }
      return '';
    }

    private get gradeName() {
      const value = this.courseList.filter((item: any) => item.productId == this.registerData.productId);
      if (value && value[0] && value[0].productDetailVos) {
        const result = value[0].productDetailVos.filter((item: any) => item.gradeId == this.registerData.gradeId);
        if (result && result[0] && result[0].gradeName) {
          const name = result[0].gradeName;
          return name;
        }
      } else {
        return '';
      }
    }

    // register
    private registerData: any = {
        	actCode: '',
      courseIds: [],
      loginName: '',
      verificationCode: '',
      verificationCodeToken: '',
    }

    private created() {
      this.systemType = OnGetOS();
      console.log('this.systemType', this.systemType);
      this.getVerificationCode();
    }
    private async checkLoginName(){
      let res = await Sign.checkLoginName({loginName:this.registerData.loginName});
      if(res.data.data){
       Message.warning('该用户名已存在请重新输入');
       return false
      }
    }
    private async getVerificationCodeToken() {
      return await Sign.getVerificationCodeToken(); // getVerificationCodeToken
    }

    private async getVerificationCode() {
      this.getVerificationCodeToken().then((result: any) => {
        this.courseRelatedData.verificationCodeToken = result.data.data;
        const codeRes = `${baseUrl}/ebopo/user/api/v1/getVerificationCode?verificationCodeToken=${result.data.data}&_t=${new Date().getTime()}`;
        this.codeImgUrl = codeRes;
      });
    }

    // 更换验证码
    private changeVerificationCode() {
      this.getVerificationCode();
    }

    // 判断课密是否正确
    private async confirmCoursePass() {
      this.courseRelatedData.loginName = this.registerData.loginName;
      return await Sign.confirmCoursePass(this.courseRelatedData);
    }

    // 查看课程包或者价格包详情
    private async getBackPackageDetail(para: any) {
      // console.log(this.courseRelatedData)
      // return false
      return await Sign.getBackPackageDetail(para);
    }

    // 课程密码获取课程相关数据
    private async getCoursePasswordToObtainCourseRelatedData() {
      return await Sign.getCoursePasswordToObtainCourseRelatedData(this.courseRelatedData);
      // console.log(res.data.code)
    }

    // 省市数据
    private async queryProvence() {
      const res = await Sign.queryProvence();
      this.queryProvenceData = res.data.data;
      this.realGradeLoading = false;
    }

    // 市级数据是否可选
    private get watchProvince() {
      return !this.registerData.province;
    }

    private get cityData() {
      const value = this.queryProvenceData.filter((item: any) => item.id == this.registerData.province);
      if (value && value[0] && value[0].childList) {
        const result = value[0].childList;
        return result;
      }
      return '';
    }

    // 获取年级数据
    private async queryGradeList() {
      const res = await Sign.queryGradeList();
      this.realGradeData = res.data.data;
      this.realGradeLoading = false;
    }

    // next
    private async next() {
      // 校验
      if (this.registerData.loginName == '') {
        Message.warning('请输入登录名'); // 1111111
        return false;
      }
      let res = await Sign.checkLoginName({loginName:this.registerData.loginName});
      if(res.data.data){
        Message.warning('该用户名已存在请重新输入');
        return false
      }
      if (!/^[a-zA-Z0-9]+$/.test(this.registerData.loginName)) {
        Message.warning('登录名请勿输入非法字符'); // 1111111
        return false;
      }
      if(this.registerData.loginName.length<6 ||this.registerData.loginName.length>18){
        Message.warning('请保证登录名长度在6~18位'); // 1111111
        return false;
      }
      // 密码规则
      if(this.registerData.passWord ==''){
        Message.warning('请输入登录密码'); // 1111111
        return false;
      }
      if(this.passwordSure == ''){
        Message.warning('请输入确认密码'); // 1111111
        return false;
      }
      if (!/^[a-zA-Z0-9]{6,18}$/.test(this.registerData.passWord)) {
        Message.warning('密码不符合规则'); // 1111111
        return false;
      }
      // 密码一致
      if (this.registerData.passWord !== this.passwordSure) {
        Message.warning('两次输入的密码不一致');
        return false;
      }
      if (this.courseRelatedData.verificationCode == '') {
        Message.warning('请输入验证码');
        return false;
      }
      if (this.courseRelatedData.verificationCode.length != 4) {
        Message.warning('验证码错误');
        return false;
      }
      if(this.courseRelatedData.courseCode ==''){
        Message.warning('请输入护照涂层内课程密码');
        return false;
      }
      // return false
      this.loading = true;
      this.confirmCoursePass().then((res: any) => {
        if (res.data.code != 0) {
          this.loading = false;
          this.getVerificationCode();
        } else {
          // console.log(res.data.data.classCodeId)
          // this.getBackPackageDetail({
          //     backPackCode: res.data.data.classCodeId
          // }).then((result: any) => {

          // })
          this.loading = false;
          console.log(res);
          this.courseList = res.data.data.packageDetail;
          this.step = 2;
        }
      }).catch((err: any) => {
        this.loading = false;
        this.getVerificationCode();
      });

      // this.step = 2;
    }

    private openCourse() {
      if (!this.registerData.productId) {
        Message.warning('请选定课程');
        return false;
      }
      // 打开弹窗
      this.dialogVisible = true;
    }

    // dialog sure
    private async dialogSure() {
      this.dialogVisible = false;
      // this.step = 3;
      const paper = Loading.service({ text: '注册中请稍后……' });
      this.loading = true;
      if (this.isDownload && this.systemType == 'windows') {
        window.open(downloadExe(),"_blank");
      }
      this.registerData.actCode = this.courseRelatedData.courseCode;

      this.registerData.courseIds = [];
      this.priorList.map((item: any) => {
        this.registerData.courseIds.push(item.courseId);
      });
      // this.registerData.loginName =
      console.log(this.registerData);
      delete this.registerData.productId;
      // return false
      const res = await Sign.newRegister(this.registerData).catch((e) => {
        paper.close();
        this.loading = false;
      });
      if (res.data.code == 0) {
        paper.close();
        this.loading = false;
        Message.success('注册成功');
        const data = {
          loginName: this.registerData.loginName,
          password: this.registerData.passWord,
        };
        const res:any = await Sign.newLogin(data).then((res) => {
          console.log(res);
          // 保存登录名
          res.data.data.loginName = this.registerData.loginName;
          window.LS.set('basicData', res.data.data);
          window.LS.set('isFirstLoading', res.data.data.userInfoFlag);
          this.$router.push('/switchCourses');
        });
        // this.$router.push(
        //         {
        //             path: '/login',
        //         }
        //     )
      }
    }

    // back
    private back() {
      this.step--;
      if (this.step === 0) {
        this.$router.go(-1);
      }
    }

    // computed title
    private get title() {
      if (this.step == 1) {
        return '填写注册基础信息';
      } if (this.step == 2) {
        return '确认开通课程';
      } if (this.step == 3) {
        return '填写用户详细信息';
      }
    }
}
